var React = require('react');

function VoEiendom32px (props) {
    return React.createElement("symbol",props,React.createElement("path",{"d":"M31.47 18.66a.98.98 0 0 1-.656.249.983.983 0 0 1-.745-.338l-1.242-1.412V29.88a1.993 1.993 0 0 1-1.987 1.994H4.989a1.993 1.993 0 0 1-1.987-1.994V17.159L1.76 18.571a.986.986 0 0 1-1.401.089.999.999 0 0 1-.088-1.407L15.169.299c.379-.43 1.112-.43 1.49 0l14.899 16.954a.999.999 0 0 1-.088 1.407zm-4.53-3.648L15.914 2.466 4.94 14.953V29.94h22V15.012zm-14.005-.092a3.92 3.92 0 0 1 2.979 1.383 3.923 3.923 0 0 1 2.98-1.383c2.191 0 3.973 1.828 3.973 4.073 0 1.047-.459 2.148-1.229 2.944-.006.007-.015.009-.022.015-.007.007-.009.017-.016.024l-5.011 4.647a.993.993 0 0 1-1.349 0l-5.011-4.647c-.007-.007-.009-.016-.016-.023-.007-.007-.016-.009-.022-.016-.77-.796-1.229-1.897-1.229-2.944 0-2.245 1.781-4.073 3.973-4.073zm2.979 9.613l4.305-3.993c.402-.419.662-1.025.662-1.547 0-1.146-.892-2.078-1.987-2.078-1.095 0-1.986.932-1.986 2.078a.995.995 0 0 1-1.987 0c0-1.146-.891-2.078-1.986-2.078s-1.987.932-1.987 2.078c0 .522.259 1.127.661 1.547l4.305 3.993z"}));
}

VoEiendom32px.displayName = "VoEiendom32px";

VoEiendom32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.82 31.88"};

module.exports = VoEiendom32px;

VoEiendom32px.default = VoEiendom32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/vo-eiendom-32px.svg
// module id = 1120
// module chunks = 0